import { render } from "./ClienteForm.vue?vue&type=template&id=2f36bb2c&scoped=true"
import script from "./ClienteForm.vue?vue&type=script&lang=js"
export * from "./ClienteForm.vue?vue&type=script&lang=js"

import "./ClienteForm.vue?vue&type=style&index=0&id=2f36bb2c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f36bb2c"]])

export default __exports__